import { useEffect, useState } from "react";
import { deleteCurso, listCursos, saveCurso } from "../../lib/data";
import type { Curso } from "../../lib/types";
import { EmptyState, Modal, Spinner } from "../../components/ui";

const BLANK: Curso = { id: "", nombre: "", nivel: "", profesor: "", cupos: 20, cuposOcupados: 0 };

export function Cursos() {
  const [items, setItems] = useState<Curso[]>([]);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [draft, setDraft] = useState<Curso>(BLANK);
  const [error, setError] = useState("");

  async function reload() {
    setLoading(true);
    try { setItems(await listCursos()); } catch (e) { setError((e as Error).message); } finally { setLoading(false); }
  }
  useEffect(() => { reload(); }, []);

  async function guardar() {
    if (!draft.nombre.trim()) return setError("Nombre obligatorio");
    try { await saveCurso(draft); setOpen(false); reload(); } catch (e) { setError((e as Error).message); }
  }

  return (
    <div className="space-y-5">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-extrabold text-slate-800">Cursos</h1>
          <p className="text-sm text-slate-500">Niveles, profesores y cupos</p>
        </div>
        <button className="btn-primary" onClick={() => { setDraft(BLANK); setError(""); setOpen(true); }}>+ Nuevo</button>
      </div>

      {loading ? <Spinner /> : items.length === 0 ? (
        <EmptyState title="Sin cursos" hint="Crea niveles como Básico, Intermedio, Avanzado." />
      ) : (
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {items.map((c) => (
            <div key={c.id} className="card p-4">
              <div className="flex items-start justify-between">
                <div>
                  <p className="font-bold text-slate-800">{c.nombre}</p>
                  <p className="text-sm text-slate-500">{c.nivel}</p>
                </div>
                <span className="badge bg-brand-50 text-brand-700">{c.cuposOcupados}/{c.cupos}</span>
              </div>
              <p className="mt-2 text-sm text-slate-500">👤 {c.profesor || "Sin profesor"}</p>
              <div className="mt-3 flex gap-2">
                <button className="btn-ghost !px-2 !py-1" onClick={() => { setDraft(c); setError(""); setOpen(true); }}>Editar</button>
                <button className="btn-danger !px-2 !py-1" onClick={async () => { if (confirm("¿Eliminar curso?")) { await deleteCurso(c.id); reload(); } }}>Eliminar</button>
              </div>
            </div>
          ))}
        </div>
      )}

      <Modal open={open} onClose={() => setOpen(false)} title={draft.id ? "Editar curso" : "Nuevo curso"}>
        <div className="space-y-3">
          <div><label className="label">Nombre</label><input className="input" value={draft.nombre} onChange={(e) => setDraft({ ...draft, nombre: e.target.value })} /></div>
          <div className="grid grid-cols-2 gap-3">
            <div><label className="label">Nivel</label><input className="input" value={draft.nivel} onChange={(e) => setDraft({ ...draft, nivel: e.target.value })} /></div>
            <div><label className="label">Profesor</label><input className="input" value={draft.profesor} onChange={(e) => setDraft({ ...draft, profesor: e.target.value })} /></div>
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div><label className="label">Cupos</label><input className="input" type="number" value={draft.cupos} onChange={(e) => setDraft({ ...draft, cupos: Number(e.target.value) })} /></div>
            <div><label className="label">Ocupados</label><input className="input" type="number" value={draft.cuposOcupados} onChange={(e) => setDraft({ ...draft, cuposOcupados: Number(e.target.value) })} /></div>
          </div>
          {error && <p className="text-sm text-rose-600">{error}</p>}
          <div className="flex justify-end gap-2 pt-2">
            <button className="btn-ghost" onClick={() => setOpen(false)}>Cancelar</button>
            <button className="btn-primary" onClick={guardar}>Guardar</button>
          </div>
        </div>
      </Modal>
    </div>
  );
}
